"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6434],{

/***/ 55267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.sunday-component-btn-primary {\n    border-radius: var(--ui-form-button-primary-enabled-border-radius);\n    border-color: var(--ui-form-button-primary-enabled-background-color);\n    background-color: var(--ui-form-button-primary-enabled-background-color);\n    * {\n      color: var(--ui-form-button-primary-enabled-text-color);\n    }\n\n    &:focus {\n      border-radius: var(--ui-form-button-primary-focused-border-radius);\n      border-color: var(--ui-form-button-primary-focused-background-color);\n      background-color: var(--ui-form-button-primary-focused-background-color);\n      * {\n        color: var(--ui-form-button-primary-focused-text-color);\n      }\n    }\n\n    &:hover {\n      border-radius: var(--ui-form-button-primary-hover-border-radius);\n      border-color: var(--ui-form-button-primary-hover-background-color);\n      background-color: var(--ui-form-button-primary-hover-background-color);\n      * {\n        color: var(--ui-form-button-primary-hover-text-color);\n      }\n    }\n\n    &:disabled {\n      border-radius: var(--ui-form-button-primary-disabled-border-radius);\n      border-color: var(--ui-form-button-primary-disabled-background-color);\n      background-color: var(--ui-form-button-primary-disabled-background-color);\n      * {\n        color: var(--ui-form-button-primary-disabled-text-color);\n      }\n    }\n  }\n\n  &.sunday-component-btn-default {\n    border-radius: var(--ui-form-button-secondary-enabled-border-radius);\n    background-color: var(--ui-form-button-secondary-enabled-background-color);\n    border-color: var(--ui-form-button-secondary-enabled-border-color);\n    * {\n      color: var(--ui-form-button-secondary-enabled-text-color);\n    }\n\n    &:hover {\n      border-radius: var(--ui-form-button-secondary-hover-border-radius);\n      background-color: var(--ui-form-button-secondary-hover-background-color);\n      border-color: var(--ui-form-button-secondary-hover-border-color);\n      * {\n        color: var(--ui-form-button-secondary-hover-text-color);\n      }\n    }\n    &:focus {\n      border-radius: var(--ui-form-button-secondary-focused-border-radius);\n      background-color: var(\n        --ui-form-button-secondary-focused-background-color\n      );\n      border-color: var(--ui-form-button-secondary-focused-border-color);\n      * {\n        color: var(--ui-form-button-secondary-focused-text-color);\n      }\n    }\n    &:disabled {\n      border-radius: var(--ui-form-button-secondary-disabled-border-radius);\n      background-color: var(\n        --ui-form-button-secondary-disabled-background-color\n      );\n      border-color: var(--ui-form-button-secondary-disabled-border-color);\n      * {\n        color: var(--ui-form-button-secondary-disabled-text-color);\n      }\n    }\n  }\n\n  &.sunday-component-btn-text {\n    padding: 0px;\n    height: fit-content;\n    width: fit-content;\n    * {\n      color: var(--ui-form-button-text-enabled-text-color);\n    }\n\n    &:hover {\n      * {\n        color: var(--ui-form-button-text-hover-text-color);\n        text-decoration: var(--ui-form-button-text-hover-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-hover-text-color);\n      }\n    }\n    &:focus {\n      * {\n        color: var(--ui-form-button-text-focused-text-color);\n        text-decoration: var(--ui-form-button-text-focused-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-focused-text-color);\n      }\n    }\n    &:disabled {\n      * {\n        color: var(--ui-form-button-text-disabled-text-color);\n        text-decoration: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Button).withConfig({
    componentId: "sc-9d032c65-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 71512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ DATE_INPUT_TEXT_FORMAT; },
/* harmony export */   "IG": function() { return /* binding */ DATE_DISPLAY_FORMAT; }
/* harmony export */ });
/* unused harmony exports SALESFORCE_DATE_AND_TIME, DATE_SLASH_FORMAT */
/* eslint-disable import/prefer-default-export */ var DATE_INPUT_TEXT_FORMAT = "YYYY-MM-DD";
var SALESFORCE_DATE_AND_TIME = "YYYY-MM-DD HH:mm:ss";
var DATE_SLASH_FORMAT = "DD/MM/YYYY";
var DATE_DISPLAY_FORMAT = {
    th: "D MMM BBBB",
    en: "D MMM YYYY"
};


/***/ }),

/***/ 54444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ INPUT_CODE; },
/* harmony export */   "n": function() { return /* binding */ RULE_CODE; }
/* harmony export */ });
var INPUT_CODE = {
    EFFECTIVE_DATE: "effectiveDate",
    INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
    INSURED_GENDER: "insuredGender",
    LEAD_REQUEST: "leadRequest",
    FULL_NAME: "fullName",
    MOBILE_NUMBER: "mobileNumber"
};
var RULE_CODE = {
    REQUIRED: "required",
    TH_ID_CARD: "thIdCard",
    RANGE_FROM_NOW: "rangeFromNow",
    IN: "in",
    CHARACTER_LENGTH: "characterLength",
    BMI: "BMI",
    ONE_BENEFICIARY_PERSON: "oneBeneficiaryPerson",
    OTP: "otp",
    LICENSE_PLATE: "licensePlate",
    AGE_BY_YEAR_0: "ageByYear0",
    AGE_BY_DAY_0: "ageByDay0",
    BENEFICIARY_PERSON_COUNT: "beneficiaryPersonCount"
};


/***/ }),

/***/ 63049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ ORDER_LIST_DATE_HOUR_MINUTE_FORMAT; },
/* harmony export */   "Do": function() { return /* binding */ formatLocalizedDateText; },
/* harmony export */   "FK": function() { return /* binding */ isAfterDateTime; },
/* harmony export */   "K_": function() { return /* binding */ DEFAULT_DATE_FORMAT; },
/* harmony export */   "Kb": function() { return /* binding */ formatDateText; },
/* harmony export */   "Md": function() { return /* binding */ MOTOR_SUMMARY_DATE_FORMAT; },
/* harmony export */   "f8": function() { return /* binding */ ORDER_LIST_DATE_LONG_FORMAT; },
/* harmony export */   "fT": function() { return /* binding */ isAfterDate; },
/* harmony export */   "gO": function() { return /* binding */ isBeforeDate; },
/* harmony export */   "s5": function() { return /* binding */ DATE_PICKER_DATE_FORMAT; },
/* harmony export */   "sE": function() { return /* binding */ isInDatePeriod; },
/* harmony export */   "z0": function() { return /* binding */ ORDER_LIST_DATE_SHORT_FORMAT; },
/* harmony export */   "zk": function() { return /* binding */ isToday; }
/* harmony export */ });
/* unused harmony exports DATE_LONG_FORMAT, getNow, getCurrentDate, parseDate, isBetweenDate */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79212);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66607);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71512);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14744);






var DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
var DATE_LONG_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
var DATE_PICKER_DATE_FORMAT = "dd/MM/yyyy";
var MOTOR_SUMMARY_DATE_FORMAT = "DD MMM YYYY";
var ORDER_LIST_DATE_SHORT_FORMAT = "DD MMM YYYY";
var ORDER_LIST_DATE_HOUR_MINUTE_FORMAT = "DD MMM YYYY HH:mm";
var ORDER_LIST_DATE_LONG_FORMAT = "DD MMM YYYY HH:mm:ss";
var getNow = function() {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
};
var getCurrentDate = function() {
    return getNow().startOf("day");
};
var parseDate = function(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_DATE_FORMAT;
    if (dayjs__WEBPACK_IMPORTED_MODULE_0___default().isDayjs(date)) {
        return date;
    }
    var newDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, format);
    if (newDate.isValid()) {
        return newDate;
    }
    throw new TypeError("Given date is invalid.");
};
var formatDateText = function(date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_format__WEBPACK_IMPORTED_MODULE_4__/* .DATE_INPUT_TEXT_FORMAT */ .AV;
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, src_constants_format__WEBPACK_IMPORTED_MODULE_4__/* .DATE_INPUT_TEXT_FORMAT */ .AV);
    if (dayjsDate.isValid()) {
        return dayjsDate.format(dateFormat);
    }
    (0,_logger__WEBPACK_IMPORTED_MODULE_5__/* .logWarn */ .yN)("Given date is invalid.");
    return "";
};
var formatLocalizedDateText = function(date, dateFormat, language) {
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, dateFormat).locale(language);
    if (dayjsDate.isValid()) {
        return dayjsDate.format(dateFormat);
    }
    (0,_logger__WEBPACK_IMPORTED_MODULE_5__/* .logWarn */ .yN)("Given date is invalid.");
    return "";
};
var isBeforeDate = function(input) {
    var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentDate();
    try {
        return date.isAfter(parseDate(input).endOf("day"));
    } catch (e) {
        return false;
    }
};
var isAfterDate = function(input) {
    var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentDate();
    try {
        return date.isBefore(parseDate(input).startOf("day"));
    } catch (e) {
        return false;
    }
};
var isAfterDateTime = function(date) {
    try {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().isAfter(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date));
    } catch (error) {
        return false;
    }
};
var isBetweenDate = function(param) {
    var from = param.from, to = param.to, _date = param.date, date = _date === void 0 ? getCurrentDate() : _date, _edgeCase = param.edgeCase, edgeCase = _edgeCase === void 0 ? false : _edgeCase, _format = param.format, format = _format === void 0 ? DEFAULT_DATE_FORMAT : _format;
    try {
        dayjs.extend(isSameOrAfter);
        dayjs.extend(isSameOrBefore);
        dayjs.extend(isBetween);
        var parsedDate = parseDate(date);
        if (edgeCase) {
            return parsedDate.isSameOrAfter(dayjs(from, format).startOf("day")) && parsedDate.isSameOrBefore(dayjs(to, format).endOf("day"));
        }
        return parsedDate.isBetween(from, to);
    } catch (e) {
        return false;
    }
};
var isToday = function(currentDate) {
    return currentDate && getNow().isSame(currentDate, "day");
};
var isInDatePeriod = function(param) {
    var from = param.from, to = param.to, _date = param.date, date = _date === void 0 ? new Date() : _date, _edgeCase = param.edgeCase, edgeCase = _edgeCase === void 0 ? false : _edgeCase;
    try {
        var fromDate = new Date(from);
        var toDate = new Date(to);
        if (edgeCase) {
            return (!from || date >= fromDate) && (!to || date <= toDate);
        }
        return (!from || date > fromDate) && (!to || date < toDate);
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 95416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RP": function() { return /* binding */ handleDisabledDate; },
  "p_": function() { return /* binding */ transformToAntValidations; },
  "_f": function() { return /* binding */ validateAge; },
  "pO": function() { return /* binding */ validateAgeBetween; },
  "JJ": function() { return /* binding */ validateBmi; },
  "oL": function() { return /* binding */ validateInListRule; },
  "c2": function() { return /* binding */ validateLicensePlate; },
  "Dd": function() { return /* binding */ validateRangeFromNowRule; },
  "xY": function() { return /* binding */ validateRequiredExcludeFalseRule; },
  "r1": function() { return /* binding */ validateRequiredRule; },
  "KK": function() { return /* binding */ validateValueByActiveInputCode; }
});

// UNUSED EXPORTS: validateFullYearRangeFromTo

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/format.ts
var format = __webpack_require__(71512);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/constants/input.ts
var input = __webpack_require__(54444);
// EXTERNAL MODULE: ./src/utils/regEx.ts
var regEx = __webpack_require__(1982);
;// CONCATENATED MODULE: ./src/utils/age.ts


var calcAgeByYear0 = function(now, dob) {
    if (typeof dob !== "string" || !dob.match(regEx/* YYYY_MM_DD_DATE_PATTERN */.G8)) {
        return -1;
    }
    var nowDayJs = dayjs_min_default()(now).startOf("day");
    var dobDayJs = dayjs_min_default()(dob).startOf("day");
    var currentYear = nowDayJs.year();
    var birthYear = dobDayJs.year();
    return Math.max(currentYear - birthYear, 0);
};
var calcAgeByDay0 = function(now, dob) {
    if (typeof dob !== "string" || !dob.match(regEx/* YYYY_MM_DD_DATE_PATTERN */.G8)) {
        return -1;
    }
    var nowDayJs = dayjs_min_default()(now).startOf("day");
    var dobDayJs = dayjs_min_default()(dob).startOf("day");
    return nowDayJs.diff(dobDayJs, "year");
};

// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
;// CONCATENATED MODULE: ./src/utils/validationRules.tsx
/* eslint-disable import/prefer-default-export */ 










/**
 * verify that the variable has a value except false.
 * @param value value for validation.
 * @returns required validation result.
 */ var validateRequiredExcludeFalseRule = function(value) {
    if (!value && value !== 0) return false;
    return true;
};
/**
 * verify that the variable has a value.
 * @param value value for validation.
 * @returns required validation result.
 */ var validateRequiredRule = function(value) {
    if (!value && value !== 0 && value !== false) {
        return false;
    }
    // Dayjs date case
    if (value && (0,dayjs_min.isDayjs)(value) && !(value === null || value === void 0 ? void 0 : value.isValid())) {
        return false;
    }
    return true;
};
/**
 * verify that the variable has in date range from now.
 * @param from number of date before current date.
 * @param to number of date after current date.
 * @param value selected date for validation.
 * @returns in range date from now validation result.
 */ var validateRangeFromNowRule = function(value) {
    var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var startDay = dayjs_min_default()().add(from - 1, "days").endOf("day");
    var lastDay = dayjs_min_default()().add(to, "days").endOf("day");
    var valueDayjs = dayjs_min_default()(value, format/* DATE_INPUT_TEXT_FORMAT */.AV);
    if ((from === 0 || from) && valueDayjs < startDay || (to === 0 || to) && valueDayjs > lastDay) {
        return false;
    }
    return true;
};
var handleDisabledDate = function(validations) {
    return function(current) {
        var rangeFromNowRule = validations.find(function(rule) {
            return rule.rule === input/* RULE_CODE.RANGE_FROM_NOW */.n.RANGE_FROM_NOW;
        });
        if (rangeFromNowRule) {
            var _params = rangeFromNowRule.params, from = _params.from, to = _params.to;
            return !validateRangeFromNowRule(current, from, to);
        }
        return false;
    };
};
/**
 * Validates the range calculated from a date to ensure it falls within a given range of years.
 * @param {Dayjs} date - The date as a Dayjs object.
 * @param {number} startYear - The start year of the range to validate against.
 * @param {number} endYear - The end year of the range to validate against.
 * @returns {boolean} - Returns true if the date is valid within the specified range, false otherwise.
 */ var validateFullYearRangeFromTo = function(date, startYear, endYear) {
    var currentDate = dayjs();
    var diff = currentDate.diff(date, "years");
    return diff >= startYear && diff <= endYear;
};
/**
 * Validates the range calculated from a date to ensure it falls within a given range of years.
 * @param {Dayjs} date - The date as a Dayjs object.
 * @param {number} startYear - The start year of the range to validate against.
 * @param {number} endYear - The end year of the range to validate against.
 * @returns {boolean} - Returns true if the date is valid within the specified range, false otherwise.
 */ var validateAgeBetween = function(date, startYear, endYear) {
    var currentDate = dayjs_min_default()();
    var diff = currentDate.year() - date.year();
    return diff >= startYear && diff <= endYear;
};
/**
 * verify that the variable has in list.
 * @param list list of values.
 * @param value value for in list rule validation.
 * @returns in list validator validation result.
 */ var validateInListRule = function(list, value) {
    if (!list.includes(value)) {
        return false;
    }
    return true;
};
/**
 * verify that the variable is correct followed the rule.
 * @param activeInputCodes list of input codes.
 * @param values value for validation.
 * @returns in list of validation result.
 */ var validateValueByActiveInputCode = function(activeInputCodes, values) {
    return activeInputCodes.map(function(activeInputCode) {
        var rulesValidation = activeInputCode.validations.map(function(rule) {
            var isRuleValidationError = false;
            switch(rule.rule){
                case input/* RULE_CODE.REQUIRED */.n.REQUIRED:
                    isRuleValidationError = !validateRequiredRule(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
                case input/* RULE_CODE.RANGE_FROM_NOW */.n.RANGE_FROM_NOW:
                    isRuleValidationError = !validateRangeFromNowRule(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode], rule.params.from, rule.params.to);
                    break;
                case input/* RULE_CODE.IN */.n.IN:
                    isRuleValidationError = !validateInListRule(rule.params.values, values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
                case input/* RULE_CODE.LICENSE_PLATE */.n.LICENSE_PLATE:
                    isRuleValidationError = !validateLicensePlate(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
            }
            return {
                code: rule.rule,
                isError: isRuleValidationError
            };
        });
        var isInputValidationError = rulesValidation.filter(function(rule) {
            return rule.isError;
        }).length > 0;
        return {
            code: activeInputCode.inputCode,
            isError: isInputValidationError,
            rulesValidation: rulesValidation
        };
    });
};
var genErrorMessage = function(message, ErrorMessageComponent) {
    if (ErrorMessageComponent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageComponent, {
            children: message
        });
    }
    return message;
};
/**
 * transform appForm validations to ant validations.
 * @param validations appForm validations.
 * @param t i18 translator.
 * @param label field label.
 * @returns ant validation.
 */ var transformToAntValidations = function(validations, t, label) {
    var isPreferWhitespace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, ErrorMessageComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isChoice = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    return [
        (0,_object_spread/* default */.Z)({
            required: !!(validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                return validation.rule === input/* RULE_CODE.REQUIRED */.n.REQUIRED;
            })),
            message: genErrorMessage(t(isChoice ? "form:validation.selectedRequired" : "form:validation.required", {
                field: label
            }), ErrorMessageComponent)
        }, isPreferWhitespace ? {
            whitespace: !!(validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                return validation.rule === input/* RULE_CODE.REQUIRED */.n.REQUIRED;
            }))
        } : null),
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_) {
                    var value, characterLengthValidation, idCardValidation, ref, ref1, ref2, ref3, ref4, ref5, max, min, ref6, idCard, digits, sum, lastDigit, inputLastDigit;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        value = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
                        characterLengthValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.CHARACTER_LENGTH */.n.CHARACTER_LENGTH;
                        });
                        idCardValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.TH_ID_CARD */.n.TH_ID_CARD;
                        });
                        if (characterLengthValidation) {
                            ;
                            max = characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref = characterLengthValidation.params) === null || ref === void 0 ? void 0 : ref.max;
                            min = characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref1 = characterLengthValidation.params) === null || ref1 === void 0 ? void 0 : ref1.min;
                            if (max && (value === null || value === void 0 ? void 0 : (ref2 = value.trim) === null || ref2 === void 0 ? void 0 : ref2.call(value).length) > (characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref3 = characterLengthValidation.params) === null || ref3 === void 0 ? void 0 : ref3.max) || min && (value === null || value === void 0 ? void 0 : (ref4 = value.trim) === null || ref4 === void 0 ? void 0 : ref4.call(value).length) < (characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref5 = characterLengthValidation.params) === null || ref5 === void 0 ? void 0 : ref5.min)) {
                                // validate only min length
                                if (min && !max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthMin", {
                                            min: min
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                // validate only max length
                                if (!min && max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthMax", {
                                            max: max
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                if (min === max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthEqualMinMax", {
                                            min: min
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                // validate min and max length
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.characterLengthMinMax", {
                                        min: min,
                                        max: max
                                    }), ErrorMessageComponent))
                                ];
                            }
                        }
                        // blame him if it wrong
                        // https://gist.github.com/peatiscoding/a16840caed0ba1b29e6b2fe171565ea0#file-assertthaiid-ts
                        if (idCardValidation) {
                            ;
                            idCard = (ref6 = value === null || value === void 0 ? void 0 : value.trim()) === null || ref6 === void 0 ? void 0 : ref6.match(/(\d{12})(\d)/);
                            if (!idCard) {
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.idCardValidation"), ErrorMessageComponent))
                                ];
                            }
                            digits = idCard[1].split("");
                            sum = digits.reduce(function(total, digit, i) {
                                return total + (13 - i) * +digit;
                            }, 0);
                            lastDigit = "".concat((11 - sum % 11) % 10);
                            inputLastDigit = idCard[2];
                            if (lastDigit !== inputLastDigit) {
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.idCardValidation"), ErrorMessageComponent))
                                ];
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};
var validateBmi = function(validations, t, sectionCode, inputCode, form) {
    var ErrorMessageComponent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    return [
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_) {
                    var value, bmiValidation, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, min, max, weightInputCode, heightInputCode, weightInputValue, heightInputValue, isWeightValid, isHeightValid, weight, height, calculatedBMI, errorMessage, fieldName, fieldErrors;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        value = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                        bmiValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.BMI */.n.BMI;
                        });
                        if (bmiValidation) {
                            ;
                            min = (bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref = bmiValidation.params) === null || ref === void 0 ? void 0 : ref.min) || 0;
                            max = (bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref1 = bmiValidation.params) === null || ref1 === void 0 ? void 0 : ref1.max) || 0;
                            weightInputCode = (ref4 = bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref2 = bmiValidation.params) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.mapInputCode) === null || ref3 === void 0 ? void 0 : ref3.find(function(code) {
                                return code.param === "weight";
                            })) === null || ref4 === void 0 ? void 0 : ref4.param;
                            heightInputCode = (ref7 = bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref5 = bmiValidation.params) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.mapInputCode) === null || ref6 === void 0 ? void 0 : ref6.find(function(code) {
                                return code.param === "height";
                            })) === null || ref7 === void 0 ? void 0 : ref7.param;
                            weightInputValue = form.getFieldValue([
                                sectionCode,
                                weightInputCode
                            ]) || "";
                            heightInputValue = form.getFieldValue([
                                sectionCode,
                                heightInputCode
                            ]) || "";
                            isWeightValid = weightInputValue.match(regEx/* DECIMAL_PATTERN */.eL);
                            isHeightValid = heightInputValue.match(regEx/* DECIMAL_PATTERN */.eL);
                            if (isWeightValid && isHeightValid) {
                                weight = weightInputValue || 0;
                                height = heightInputValue || 0;
                                calculatedBMI = weight / Math.pow(height / 100, 2);
                                errorMessage = genErrorMessage(t("form:validation.invalidBMI"), ErrorMessageComponent);
                                fieldName = inputCode !== weightInputCode ? weightInputCode : heightInputCode;
                                fieldErrors = form.getFieldError([
                                    sectionCode,
                                    fieldName
                                ]).filter(function(error) {
                                    if (typeof error === "object" && typeof errorMessage === "object") {
                                        return error.props.children !== errorMessage.props.children;
                                    }
                                    return error !== errorMessage;
                                });
                                if (weight <= 0) {
                                    if (height) {
                                        form.setFields([
                                            {
                                                name: [
                                                    sectionCode,
                                                    heightInputCode
                                                ],
                                                errors: []
                                            }
                                        ]);
                                    }
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                if (height <= 0) {
                                    if (weight) {
                                        form.setFields([
                                            {
                                                name: [
                                                    sectionCode,
                                                    weightInputCode
                                                ],
                                                errors: []
                                            }
                                        ]);
                                    }
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                if (isFinite(calculatedBMI) && (calculatedBMI > max && max || calculatedBMI < min && min || calculatedBMI <= 0)) {
                                    // update pair params bmi errors
                                    form.setFields([
                                        {
                                            name: [
                                                sectionCode,
                                                fieldName
                                            ],
                                            errors: [
                                                errorMessage
                                            ]
                                        }
                                    ]);
                                    return [
                                        2,
                                        Promise.reject(errorMessage)
                                    ];
                                }
                                if (weight <= 0 || height <= 0 || isFinite(calculatedBMI) && (calculatedBMI > max && max || calculatedBMI < min && min || calculatedBMI <= 0)) {
                                    // update pair params bmi errors
                                    form.setFields([
                                        {
                                            name: [
                                                sectionCode,
                                                fieldName
                                            ],
                                            errors: [
                                                errorMessage
                                            ]
                                        }
                                    ]);
                                    return [
                                        2,
                                        Promise.reject(errorMessage)
                                    ];
                                }
                                // remove bmi validate errors
                                form.setFields([
                                    {
                                        name: [
                                            sectionCode,
                                            fieldName
                                        ],
                                        errors: (0,_to_consumable_array/* default */.Z)(fieldErrors)
                                    }
                                ]);
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};
/**
 * Check format of license plate
 * the format is ก-ฮ or a-z or A-D at least 1 character and end with 3 arabic numeral
 * example:
 * 1AB4444 is pass,
 * 9 is fail,
 * กV3333 is pass,
 * DV333A is fail,
 * @param value String that you want to check
 * @returns If match, it will return true
 */ var validateLicensePlate = function(value) {
    var result = /^(?=.*[0-9])(?=.*[\u0E00-\u0E7Fa-zA-Z])(.*[0-9])$/.test(value);
    return result;
};
var validateAge = function(validations, t, refDate) {
    var ErrorMessageComponent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, errorMessage = arguments.length > 4 ? arguments[4] : void 0;
    return [
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_, value) {
                    var dob, ageByYear0Validation, ageByDay0Validation, ref, ref1, ageByYear0, min, max, validErrorMessage, ref2, ref3, age, min1, max1, validErrorMessage1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (value) {
                            dob = (0,date/* formatDateText */.Kb)(value);
                            ageByYear0Validation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                                return validation.rule === input/* RULE_CODE.AGE_BY_YEAR_0 */.n.AGE_BY_YEAR_0;
                            });
                            ageByDay0Validation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                                return validation.rule === input/* RULE_CODE.AGE_BY_DAY_0 */.n.AGE_BY_DAY_0;
                            });
                            if (ageByYear0Validation) {
                                ;
                                ageByYear0 = calcAgeByYear0(refDate, dob);
                                min = (ageByYear0Validation === null || ageByYear0Validation === void 0 ? void 0 : (ref = ageByYear0Validation.params) === null || ref === void 0 ? void 0 : ref.min) || 0;
                                max = (ageByYear0Validation === null || ageByYear0Validation === void 0 ? void 0 : (ref1 = ageByYear0Validation.params) === null || ref1 === void 0 ? void 0 : ref1.max) || Infinity;
                                if (ageByYear0 < min || ageByYear0 > max) {
                                    validErrorMessage = errorMessage || genErrorMessage(t("form:validation.invalidAge"), ErrorMessageComponent);
                                    return [
                                        2,
                                        Promise.reject(validErrorMessage)
                                    ];
                                }
                            }
                            if (ageByDay0Validation) {
                                ;
                                age = calcAgeByDay0(refDate, dob);
                                min1 = (ageByDay0Validation === null || ageByDay0Validation === void 0 ? void 0 : (ref2 = ageByDay0Validation.params) === null || ref2 === void 0 ? void 0 : ref2.min) || 0;
                                max1 = (ageByDay0Validation === null || ageByDay0Validation === void 0 ? void 0 : (ref3 = ageByDay0Validation.params) === null || ref3 === void 0 ? void 0 : ref3.max) || Infinity;
                                if (age < min1 || age > max1) {
                                    validErrorMessage1 = errorMessage || genErrorMessage(t("form:validation.invalidAge"), ErrorMessageComponent);
                                    return [
                                        2,
                                        Promise.reject(validErrorMessage1)
                                    ];
                                }
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_, value) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};


/***/ })

}]);